export default {"src":"/_next/static/media/googleIcon.cef29757.svg","height":32,"width":29,"blurWidth":0,"blurHeight":0};